import { render, staticRenderFns } from "./notification-primary.vue?vue&type=template&id=63b876f4&"
import script from "./notification-primary.vue?vue&type=script&lang=js&"
export * from "./notification-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports